module.exports = __webpack_public_path__ + "static/media/ATC.1497ed0f.png";